import React from 'react';
import { UserIcon } from 'lucide-react';
import { borrower } from '../data/reports';
export function BorrowerHeader() {
  return <header className="border-b border-ink-100 bg-white" data-id="element-6" data-mp="33ezd5duqx50v">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-4 px-6 py-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-7" data-mp="2pmjhwz836bai">
        <div className="flex items-center gap-3" data-id="element-8" data-mp="2um5s0zsmbbf3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand-600" aria-hidden="true" data-id="element-9" data-mp="3iap3fo6ys4be">
            <UserIcon className="h-5 w-5" data-id="element-10" data-mp="3mbhbie43o363" />
          </span>
          <div data-id="element-11" data-mp="38daq3xgc7vnb">
            <h1 className="text-lg font-semibold leading-tight text-ink-900" data-id="element-12" data-mp="38bpsu02n1ylr">
              {borrower.name}
            </h1>
            <p className="mt-0.5 text-sm leading-tight text-ink-500" data-id="element-13" data-mp="3ddoxree113kt">
              Loan {borrower.loanNumber} · SSN {borrower.ssnMasked} ·
              Co-borrower {borrower.coBorrower}
            </p>
          </div>
        </div>
        <span className="inline-flex w-fit items-center rounded-full bg-ink-50 px-3 py-1 text-xs font-medium text-ink-700 ring-1 ring-inset ring-ink-100" data-id="element-14" data-mp="18r936gx3be89">
          Credit &amp; Liabilities
        </span>
      </div>
    </header>;
}